// extracted by mini-css-extract-plugin
export default {"wrap":"MobileNavWrap_wrap__bnGbn"};